var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_23099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4981 0L11.3438 0.524139V15.7321L11.4981 15.886L18.5573 11.7133L11.4981 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4979 0L4.43848 11.7133L11.4979 15.886V8.50452V0Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4981 17.2224L11.4111 17.3284V22.7457L11.4981 22.9996L18.5616 13.0518L11.4981 17.2224Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4979 22.9996V17.2224L4.43848 13.0518L11.4979 22.9996Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.498 15.8859L18.5573 11.7131L11.498 8.50439V15.8859Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43848 11.7131L11.4979 15.8859V8.50439L4.43848 11.7131Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_23099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/EthereumLogo.0e0093505e8d5714058b1a8c268612a7.svg";
export { ForwardRef as ReactComponent };